import { Flex, Text } from '@chakra-ui/react';
import { faWarning } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@morressier/alembic';
import { useState } from 'react';

const ExitWithoutSavingWarningModal = ({
  onClose
}: {
  onClose: () => void;
}) => {
  const [showExitConfirmModal, setShowExitConfirmModal] = useState(false);
  return (
    <>
      <Button
        variant="caution"
        type="button"
        onClick={() => setShowExitConfirmModal(true)}
      >
        Exit Without Saving
      </Button>

      <Modal
        isOpen={showExitConfirmModal}
        onClose={() => setShowExitConfirmModal(false)}
        width={{ base: 'calc(100vw - 16px)', md: '500px' } as any}
      >
        <Flex direction="column" gap={4} p={{ base: 3, md: 6 }}>
          <Text textStyle="headingSection">
            <FontAwesomeIcon icon={faWarning} /> Exit without saving?
          </Text>
          <Text textStyle="textBody">
            You have unsaved changes. If you exit now, your changes will be
            lost. Do you want to continue?
          </Text>

          <Flex justifyContent="flex-end" gap={2}>
            <Button
              variant="secondary"
              type="button"
              onClick={() => setShowExitConfirmModal(false)}
            >
              Cancel
            </Button>
            <Button variant="caution" type="button" onClick={onClose}>
              Exit
            </Button>
          </Flex>
        </Flex>
      </Modal>
    </>
  );
};

export default ExitWithoutSavingWarningModal;
